import RecordingOptOut from '../../src/components/OptOut/RecordingOptOut'
import Footers from '../../src/components/Footer'
import Header from '../../src/components/Header'
import UserDataPreferences from '../../src/components/UserDataPreferences'

export default function Page() {
  return (
    <>
      <Header />
      <div className="cure-inner-container">
        <UserDataPreferences />
      </div>
      <Footers />
    </>
  )
}